export default function Paginacion({
  pagina,
  totalPaginas,
  onChange,
  rango = 2,
  disabled = false,
}) {
  const total = Math.max(Number(totalPaginas) || 0, 0);

  if (total <= 1) {
    return null;
  }

  const paginaActual = Math.min(
    Math.max(Number(pagina) || 1, 1),
    total
  );

  const rangoNormalizado = Math.max(Number(rango) || 0, 0);
  const items = [];

  for (let i = 1; i <= total; i++) {
    const mostrarPagina =
      i === 1 ||
      i === total ||
      Math.abs(i - paginaActual) <= rangoNormalizado;

    if (mostrarPagina) {
      items.push(i);
    } else if (items[items.length - 1] !== '...') {
      items.push('...');
    }
  }

  const uniqueItems = [];

  for (const item of items) {
    if (item === '...' || !uniqueItems.includes(item)) {
      uniqueItems.push(item);
    }
  }

  const goTo = (destino) => {
    const paginaDestino = Number(destino);

    if (
      !Number.isFinite(paginaDestino) ||
      paginaDestino < 1 ||
      paginaDestino > total ||
      paginaDestino === paginaActual ||
      disabled ||
      typeof onChange !== 'function'
    ) {
      return;
    }

    onChange(paginaDestino);
  };

  return (
    <nav
      className={`custom-pagination ${disabled ? 'is-disabled' : ''}`.trim()}
      aria-label='Navegación de páginas'
    >
      <ul className='pagination-list'>
        <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
          <button
            type='button'
            onClick={() => goTo(1)}
            disabled={disabled || paginaActual === 1}
            aria-label='Primera página'
            title='Primera página'
          >
            «
          </button>
        </li>

        <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
          <button
            type='button'
            onClick={() => goTo(paginaActual - 1)}
            disabled={disabled || paginaActual === 1}
            aria-label='Página anterior'
            title='Página anterior'
          >
            ‹
          </button>
        </li>

        {uniqueItems.map((item, index) =>
          item === '...' ? (
            <li key={`dots-${index}`} className='page-item disabled'>
              <span aria-hidden='true'>…</span>
            </li>
          ) : (
            <li
              key={`page-${item}`}
              className={`page-item ${item === paginaActual ? 'active' : ''}`}
            >
              <button
                type='button'
                onClick={() => goTo(item)}
                disabled={disabled || item === paginaActual}
                aria-current={item === paginaActual ? 'page' : undefined}
                aria-label={`Página ${item}`}
                title={`Página ${item}`}
              >
                {item}
              </button>
            </li>
          )
        )}

        <li className={`page-item ${paginaActual === total ? 'disabled' : ''}`}>
          <button
            type='button'
            onClick={() => goTo(paginaActual + 1)}
            disabled={disabled || paginaActual === total}
            aria-label='Página siguiente'
            title='Página siguiente'
          >
            ›
          </button>
        </li>

        <li className={`page-item ${paginaActual === total ? 'disabled' : ''}`}>
          <button
            type='button'
            onClick={() => goTo(total)}
            disabled={disabled || paginaActual === total}
            aria-label='Última página'
            title='Última página'
          >
            »
          </button>
        </li>
      </ul>
    </nav>
  );
}
